<template>
    <div class="static-heaer background">
        <div class="texto">
            <h1 class="b-title" style="font-size: 3.2rem; font-weight: 700; color: yellow">Comunicaciones efectivas en TELEMEDICINA<br>
            </h1>
            <div class="b-title">Sabemos que la comunicación es la piedra angular de toda relación, y en el binomio paciente-profesional de la salud, es INDISPENSABLE!<br>
                Con la realidad viva de la Telemedicina y la Telesalud, que LLEGO PARA QUEDARSE, resulta doblemente desafiante ya que debemos franquear no solamente los obstáculos de comunicación tradicionales en este singular binomio, sino que además debemos considerar los aspectos tecnológicos y propios de las pantallas, que deben integrarse a la realidad que vive el paciente, a fin de hacer la experiencia en telesalud en general de un nivel “3E”: Ética, Exitosa y Efectiva.
            </div>
            <div style="display: flex; justify-content: center;text-align: center; flex-direction: column; align-items: center">
                <h2 style="font-weight: bold; color: white">INVERSIÓN: 137$</h2>
                <a href="https://cambiandotusalud.com/checkout/137/a79cd41a617c3901f4e9759b99cee2935d674e080650e253f1d8f598b0bddc35" target="_blank" class="boton_a">INSCRIBETE ÁQUI!</a>
            </div>
        </div>
        <div class="image">
            <img src="/image/resource/omidres-miguel-01.png" class="image_o"/>
        </div>
        <span v-if="modal === true">
            <transition name="modal">
                <div class="modal-mask">
                  <div class="modal-wrapper">
                    <div class="modal-container">

                      <div class="modal-body">
                        <form-landing :data_landing="data_landing"></form-landing>
                      </div>

                      <div class="modal-footer">
                        <slot name="footer">
                          <button class="modal-default-button" @click="modal = false">
                            CANCELAR
                          </button>
                        </slot>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
        </span>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    import formLanding from './../resources/formLandingEvent.vue'
    export default {
        name: '',
        components: {
            formLanding
        },
        created(){

        },
        data(){
            return {
                image:'https://firebasestorage.googleapis.com/v0/b/omidressite.appspot.com/o/proyects%2Fomidres-site%2Fslider%2Fheader%20web-01.jpg?alt=media&token=c8b863c0-d131-4856-84b4-0cc082dac9fa',
                showModal: false,
                modal: false,
                postRegister:false,
                description:true,
                data_landing:{
                    urlRoom:'#1 ingresa al canal de TELEGRAM, EL ABC DE LA TELEMEDICINA y alli te daremos los demás pasos a seguir....nos vemos en telegram!',
                    id_room:'https://t.me/ABCdelatelemedicina',
                    date:'Del 6 y 10 de Julio - Hora 7:00 PM MX - CO - EC / 8:00PM Hora PM Miami - Venezuela',
                    title: 'El ABC de la Telemedicina',
                    tag:'ABC-Telemedicina',
                    type:'2',
                    url_download:''
                }
            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>
<style scoped>
    .background{
        background: rgb(121,9,81);
        background: linear-gradient(90deg, rgba(121,9,81,1) 0%, rgba(255,59,0,1) 100%);
    }
    .boton_a{
        width: 290px;
        height: 90px;
        background-color: #FF4500;
        border: solid 1px white;
        border-radius: 10px;
        color: white;
        font-weight: 700;
        padding-top: 10px;
        cursor: pointer;
        font-size: 2rem;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .static-heaer{
        display: flex;
        flex-direction: row;
        justify-content: space-around;

        min-height: 100vh;
        background-size: cover;
        background-repeat: no-repeat;
        overflow-x : hidden;
        overflow-y : hidden
    }
    .image{
        width: 45%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-end;
    }
    .image_o{
        width: 90%;
    }
    .texto{
        width: 55%;
        color: white;
        display: flex;
        flex-direction: column;
        font-size: 3rem;
        align-content: flex-start;
        justify-content: flex-start;
        margin-top: 120px;
        margin-left: 100px;
        text-shadow: 2px 2px 2px #0F4F84;
        font-family: 'Gayathri', sans-serif;
        padding-bottom: 20px;
    }
    .b-title{
        font-size: 1.5rem;
        line-height: 2.8rem;
        font-weight: 500;
        text-align: center;
    }
    .glucometro{
        margin-left: 160px;
        animation-duration: 3s
    }
    .img_g{
        width: 50%;
    }

    @media (min-width: 10px) and (max-width: 480px) {
        .static-heaer{
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: auto;
            overflow-x : hidden;
            overflow-y : hidden
        }
        .texto{
            text-align: center;
            min-width: 320px;
            color: white;
            display: flex;
            flex-direction: column;
            margin-left: 5px;
            justify-content: flex-start;
            text-shadow: 2px 2px 2px #0F4F84;
            font-family: 'Gayathri', sans-serif;

        }
        .image{
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
        }

        .b-title{
            font-size: 1.5rem;
            line-height: 2.5rem;
            font-weight: 500;
            min-width: 320px
        }

    }
</style>